export default class AuthMultipleOnBehalfOfError extends Error {
    constructor(options) {
        super();
        this.name = 'AuthMultipleOnBehalfOfError';
        this.message = 'Your scope contains multiple on_behalf_of claims. This is not allowed!';
        this.cause = options === null || options === void 0 ? void 0 : options.cause;
    }
}
